import { render } from "./Spinner.vue?vue&type=template&id=0791fc40&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=0791fc40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0791fc40"

export default script